module.exports = __webpack_public_path__ + "static/media/zera_walking_01.220c51a2.gif";